import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux'

import { ISearchTableState } from '../../shared/interfaces';

import { ITag, IBasePicker} from '@fluentui/react';
import { reduxActions, RootState } from '../../store';

import { RoleContext} from '../../shared/enums';


import { checkRoles } from '../../hoc/CheckRoles';
import { CancelTokenSource } from 'axios';
import SearchComponentBase from './SearchComponentBase';





const mapState = (state: RootState) => ({
    currentUser: state.sessionReducer.currentUser,
    currentAoo: state.sessionReducer.currentAoo,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    protocolsTableState: state.appNavigationReducer.searchTableState
})

const mapDispatch = {
    setProtocolsTableState: (protocolsTableState: (ISearchTableState)) => (reduxActions.appNavigationActions.setProtocolsTableState(protocolsTableState)),
    unsetProtocolsTableState: () => (reduxActions.appNavigationActions.unsetProtocolsTableState()),
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface SearchPageState {
}
export interface SearchPageProps {
}

type Props = SearchPageProps & RouteComponentProps & PropsFromRedux

class SearchPage extends React.Component<Props, SearchPageState> {
    tagPickerRef = React.createRef<IBasePicker<ITag>>();
    cancelTokenSources = {};

    constructor(props) {
        super(props);
        this.state = {
        
        };
    }


    componentWillUnmount() {
        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
    }
      



    public render() {

        return (
            <SearchComponentBase />

        );
    }

}



export default connector(withRouter(checkRoles(SearchPage, RoleContext.Aoo)));




